import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { Section, Stack } from "@origin-digital/ods-core";
import { navigation } from "@origin-digital/reporting-client";
import { actionBarUpdate } from "@origin-digital/event-dispatcher";
import { SpaceVariants } from "@origin-digital/ods-types";
import { ChatController } from "../components/Chat";
import { Head } from "../components/Head";
import { IMetadata } from "../../../shared/interface/metadata";
import { INavigationCustom } from "../../functional-test/pages/INavigationCustom";

interface IScreenTemplateProps {
  "data-id"?: string;
  children: React.ReactNode;
  isHome?: boolean;
  metadata?: IMetadata;
  searchTerm?: string;
  space?: SpaceVariants;
}

export const ScreenTemplate = ({
  "data-id": dataId,
  children,
  isHome,
  metadata,
  searchTerm,
  space = "none",
}: IScreenTemplateProps) => {
  const { category, subCategory, article } = useParams();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [category, subCategory, article]);

  useEffect(() => {
    navigation("screen", {
      currentUri: window.location.host + window.location.pathname,
      friendlyUri: window.location.pathname
        .replace(/\/$/, "")
        .replace(/^\//, "")
        .replace(/\//g, ":"),
      searchTerm,
    } as INavigationCustom);

    actionBarUpdate({
      mobileNavButton: "back",
      component: isHome ? "h1" : "h3",
    });
  }, []);

  return (
    <Stack space="none">
      <Head metadata={metadata} />
      <Stack space={space} data-id={dataId}>
        {/* Empty <div /> here adds padding between stacked elements */}
        <div />
        {children}
        <Section backgroundColor="white" paddingY="medium">
          <ChatController />
        </Section>
        {/* Empty <div /> here adds padding between stacked elements */}
        <div />
      </Stack>
    </Stack>
  );
};
